import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useSharedState } from '../../hooks/SharedStateContext';
import ModalGeneric from './ModalGeneric';

const MicrophonePermissionModal = ({
  isOpen,
  onPermissionGranted,
  onPermissionDenied = () => {}
}) => {
  const { t } = useTranslation();
  const { sharedState } = useSharedState();

  const requestMicrophonePermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: sharedState.echoCancellation,
          noiseSuppression: sharedState.noiseSuppression,
          autoGainControl: sharedState.autoGainControl
        }
      });
      stream.getTracks().forEach(track => track.stop());
      onPermissionGranted();
      return true;
    } catch (error) {
      console.error('Microphone permission denied:', error);
      onPermissionDenied(error);
      return false;
    }
  };

  return (
    <ModalGeneric
      title={t('microphone_permission_required')}
      isOpen={isOpen}
      onClose={onPermissionDenied}
    >
      <div style={{ textAlign: 'center' }}>
        <div style={{ marginBottom: '20px' }}>
          <FontAwesomeIcon icon={faMicrophone} size="3x" color="#007bff" />
        </div>

        <p style={{ marginBottom: '20px' }}>
          {t('microphone_permission_message')}
        </p>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button
            onClick={requestMicrophonePermission}
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            <FontAwesomeIcon icon={faMicrophone} style={{ marginRight: '8px' }} />
            {t('allow_microphone')}
          </button>

          <button
            onClick={onPermissionDenied}
            style={{
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            {t('cancel')}
          </button>
        </div>
      </div>
    </ModalGeneric>
  );
};

export default MicrophonePermissionModal;
